module.exports = {"account_number_enter":"E.g. NL42 ABNA 1234 5678 90","account_number_hint":"The account number on which we will pay your balance","account_number":"IBAN","account_number_error_notvalid":"Your IBAN is not valid","account_number_title":"Your IBAN","invalid_account_number":"Are you sure the IBAN entered is correct?"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/iban.json
// module id = 527
// module chunks = 245 971